import { Box } from '@mui/material';
import React from 'react';

const TableHeader = ({title}:{title:string}) => {
  return (
    <Box className=" mt-1 w-full font-bold h-[50px] min-h-[50px] max-h-[50px] flex items-center border-t-2 shadow-lg border-l-2 border-b-2 rounded-md">
      <div className="w-[80px]  border-r-2 h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
        N° indicat.
      </div>
      <div className="w-[200px] border-r-2 h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
        Indicateur {title}
      </div>
      <div className="h-full flex flex-grow">
        <div className="w-[60px] flex-grow border-r-2   flex-col pl-[2px] h-full flex items-center  justify-center bg-[#f3f6f8] text-[#0099F2] text-xs capitalize">
          <span> SNTE </span> <span>oui/non</span>
        </div>
        <div className="w-[60px] flex-grow border-r-2 pl-[2px] h-full flex flex-col items-center  justify-center bg-[#f3f6f8] text-[#28B66F] text-xs capitalize">
          <span>Valeur</span> <span>début</span>
        </div>
        <div className="w-[60px] flex-grow border-r-2 pl-[2px] h-full flex flex-col items-center  justify-center bg-[#f3f6f8] text-[#28B66F] text-xs capitalize">
          <span>Valeur</span> <span>cible</span>
        </div>
        <div className="w-[60px] flex-grow border-r-2 h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
          Fin 24
        </div>
        <div className="w-[60px] flex-grow border-r-2 h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
          fin 25
        </div>
        <div className="w-[60px] flex-grow border-r-2 h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
          mi-26
        </div>
        <div className="w-[60px] flex-grow border-r-2 h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
          fin 26
        </div>
        <div className="w-[60px] flex-grow border-r-2 h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
          mi-27
        </div>
        <div className="w-[60px] flex-grow border-r-2 h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
          fin 27
        </div>
        <div className="w-[60px] flex-grow border-r-2 h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
          mi 28
        </div>
        <div className="w-[60px] flex-grow border-r-2 h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
          fin 28
        </div>
        <div className="w-[60px] flex-grow border-r-2 h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
          mi 29
        </div>
        <div className="w-[60px] flex-grow border-r-2  h-full  flex items-center justify-center bg-[#f3f6f8] text-xs capitalize">
          fin 29
        </div>
      </div>
    </Box>
  );
};

export default TableHeader;
